<template>
    <section class="barocare-conci-hospital" id="barocare-conci-intro">
        <div class="nonface-cont" >
            <div class="nonface-container-lg" >
                <div class="title-area" v-intersect>
                    <div class="title-left">
                      <h2 class="text-xl"> 
                      재처방 주기에 맞게
                      <br>리마인드 서비스 지원
                      </h2>
                  </div>
                  <div class="title-right">
                   <p>
                    맞추기 어려운 <strong>재진료 / 재구매 주기</strong><br>
                    저희가 대신 챙겨드릴게요
                    </p>           
                  </div>
                </div>
                <div class="box-lg" v-intersect>
                  <img src="../../assets/pc_barocare_conci/bg-remind.jpg" alt="원하는 시간진료 예약, 의사선생님과 전화 진료">  
                  <div class="cont-box">
                    <div class="header">재구매 시점 도래 안내</div>
                    <p>소모성 재료 잔여분 확인 후 <br> 필요한 경우 진료를 신청해 주세요.</p>
                    <a href="#;" class="btn-appli">진료 신청하기</a>
                  </div>
              </div>      
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'BarocareConciIntro',
    directives: {
        intersect: {
            // 요소가 DOM에 삽입될 때 호출됩니다.
            inserted(el) {
                const options = {
                    root: null, // 뷰포트를 기본값으로 설정
                    rootMargin: '0px', // 뷰포트의 마진은 0
                    threshold: 0.1 // 10%가 보일 때 콜백이 실행
                };
                const callback = (entries, observer) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            el.classList.add('visible');
                        } else {
                            el.classList.remove('visible');
                        }
                    });
                };
                const observer = new IntersectionObserver(callback, options);
                observer.observe(el); // 해당 요소를 관찰 시작
            }
        }
    },
}
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/pc_barocare_conci/BarocareConciHospital.vue